<template>
  <div class="modal modal-cart-ty fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center modal-cart-ty__content" v-if="order">
        <button type="button" class="modal__close d-flex align-items-center justify-content-center" data-dismiss="modal">
          <svg-icon icon="close-remove"></svg-icon>
        </button>

        <div class="modal-cart-ty__svg pb-3">
          <svg-icon icon="leaves"></svg-icon>
        </div>

        <div class="modal-cart-ty__title pb-3">Спасибо за заказ!</div>

        <div class="modal-cart-ty__subtitle pb-4">
          Ваш заказ <a :href="order_url" class="link-blue">№{{order.id}}</a> успешно оформлен.
          <br>
          На указанную электронную почту отправлено письмо с данными по заказу и ссылкой на него.
          <br>
          Сейчас вы будете перенаправлены на страницу заказа, где вы сможете посмотреть информацию по заказу и оплатить его. Если этого не произошло, нажмите на кнопку ниже.
        </div>

        <div class="text-center pb-5">
          <a class="button-green modal-cart-ty__button" :href="order_url">Перейти на страницу заказа</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        order : null,
        order_url : null,
      }
    },
    computed : {

    },
    methods: {
      setContent(order, order_url) {
        this.order = order
        this.order_url = order_url
      },
    },
    mounted() {

    },
    components: {

    },
    watch : {

    }
  }
</script>
